export const loginValues = {
  // reloadType 파라미터가 있으나 로그인 후 리다이렉트 하지 않는 경로
  noRedirectPath: ['/community/srr/review', '/courseReview']
}
